<template>
  <RevCard>
    <div class="flex flex-col items-center p-24 md:flex-row">
      <div class="flex md:items-center">
        <RevIllustration
          v-if="image"
          alt=""
          :height="80"
          :src="image"
          :width="80"
        />

        <div class="ml-32">
          <p class="body-1-bold">{{ title }}</p>
          <p class="text-static-default-low body-2">
            {{ i18n(translations.productId, { id }) }}
          </p>
        </div>
      </div>

      <RevButton
        class="ml-auto w-auto max-md:hidden"
        size="small"
        :to="createListingLink"
        variant="primary"
      >
        {{ i18n(translations.buyItem) }}
      </RevButton>
      <RevButton
        class="mt-16 w-full md:hidden"
        :to="createListingLink"
        variant="primary"
      >
        {{ i18n(translations.buyItem) }}
      </RevButton>
    </div>

    <RevAccordionItem class="border-t-2 border-[#f2f2f2] px-32 py-20">
      <template #title>
        {{ i18n(translations.moreDetails) }}
      </template>

      <template #body>
        <div class="flex space-x-24 border-b-2 border-[#f2f2f2] py-16">
          <p class="body-1-bold w-1/4">
            {{ i18n(translations.attributes) }}
          </p>
          <p class="body-1-bold w-3/4">
            {{ i18n(translations.specifications) }}
          </p>
        </div>
        <div
          v-for="attributePair in attributes"
          :key="attributePair.id"
          class="flex space-x-24 border-b-2 border-[#f2f2f2] py-16"
        >
          <p class="body-1 w-1/4">
            {{ attributePair.label }}
          </p>
          <p class="body-1-bold w-3/4">
            {{ attributePair.value }}
          </p>
        </div>
      </template>
    </RevAccordionItem>
  </RevCard>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevAccordionItem } from '@ds/components/AccordionItem'
import { RevButton } from '@ds/components/Button'
import { RevCard } from '@ds/components/Card'
import { RevIllustration } from '@ds/components/Illustration'

import { ROUTE_NAMES } from '~/constants/routes'
import type { ProductAlgoliaHitAttribute } from '~/scopes/buyback/pages/search-product/SearchProductAdapter'

import translations from './ProductDetails.translations'

const i18n = useI18n()
const props = withDefaults(
  defineProps<{
    id: string
    title: string
    image: string | null
    attributes?: ProductAlgoliaHitAttribute[]
  }>(),
  { attributes: () => [] },
)

const createListingLink = {
  name: ROUTE_NAMES.BUYBACK.CREATE_QUOTATION,
  params: {
    productId: props.id,
  },
}
</script>
